import { z } from "zod";
import { email } from "./schemas/email";
import { firstName } from "./schemas/first-name";
import { lastName } from "./schemas/last-name";
import { phone } from "./schemas/phone";
import { postalCode } from "./schemas/postal";

export const careGiverLeadFormSchema = z.object({
  step1: z.object({
    Role: z.literal("caregiver"),
  }),
  step2: z.object({
    BusinessInEnglish: z.boolean().refine((val) => val === true, {
      error: "You must be able to conduct business in English",
    }),
    CanWorkInUS: z.boolean().refine((val) => val === true, {
      error: "You must be eligible to work in the US",
    }),
    ConsentTerms: z.boolean().refine((val) => val === true, {
      error: "You must consent to the terms",
    }),
    Email: email,
    FirstName: firstName,
    jobID: z.string().refine((val) => val.length > 0 && val !== "0", {
      error: "You must select a job",
    }),
    LastName: lastName,
    OptInEmail: z.boolean().default(true),
    OptInSms: z.boolean().default(false),
    organizationNumber: z.number(),
    Phone: phone,
    // This is the postal code provided by the LocationSelect component we send to our backend
    postalCode: z.string(),
    userEnteredLocation: postalCode,
  }),
});

export type CareGiverLeadFormData = z.input<typeof careGiverLeadFormSchema>;

export type CareGiverLeadFormResponseError =
  | "duplicate"
  | "server-error"
  | "validation-error";

export type CareGiverLeadFormResponse = {
  isError: boolean;
  errors: { code: string; reason: string; detail: string; source: string }[];
  message: string;
  id?: string;
  jobID?: string;
  jobApplicationURL?: string;
};

export const parseCareGiverFormData = (formData: FormData) => {
  return {
    step1: {
      Role: formData.get("step1.Role") || "caregiver",
    },
    step2: {
      BusinessInEnglish: formData.get("step2.BusinessInEnglish") === "on",

      CanWorkInUS: formData.get("step2.CanWorkInUS") === "on",
      ConsentTerms: formData.get("step2.ConsentTerms") === "on",
      Email: formData.get("step2.Email"),
      FirstName: formData.get("step2.FirstName"),

      // Job ID as selected by user in caregiver form
      jobID: formData.get("step2.jobID"),
      LastName: formData.get("step2.LastName"),

      // Opt in to email by submitting form
      OptInEmail: true,

      // Opt in to SMS by checking checkbox
      OptInSms: formData.get("step2.ConsentTerms") === "on",
      organizationNumber: Number(formData.get("step2.organizationNumber")),
      Phone: formData.get("step2.Phone"),

      // derived value from LocationSelect
      postalCode: formData.get("step2.postalCode"),

      // raw user input
      userEnteredLocation: formData.get("step2.userEnteredLocation"),
    },
  };
};
